import { isDefined } from '@interacta-shared/util';
import {
    AppBaseRoute,
    AppRoute,
    dashboardRoutes,
    digitalWorkplaceRoutes,
    postDetailRoutes,
    toBaseRoute,
} from '@modules/app-routing/routes';

export const CONVO_AI_ENABLED_ROUTES: AppRoute[] = [
    ...dashboardRoutes,
    ...digitalWorkplaceRoutes,
    ...postDetailRoutes,
];

export const CONVO_AI_ENABLED_BASE_ROUTES: AppBaseRoute[] = Array.from(
    new Set(CONVO_AI_ENABLED_ROUTES.map(toBaseRoute).filter(isDefined)),
);
